module.exports = __webpack_public_path__ + "img/Weapon_60.0c13035b.png";